<template>
    <div id="app" data-cy="app-container">
        <!--<div v-if="darkLayerEnabled" class="dark-layer"></div>-->
        <component :is="`${layout}-layout`" :data-cy="`${layout}-layout`">
            <router-view />
        </component>
    </div>
</template>

<script>
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Filler,
    Legend,
    TimeScale,
    ArcElement,
    BarElement,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale
} from 'chart.js';
import Zoom from 'chartjs-plugin-zoom';
import '@/helpers/chartjs/dayjs-adapter';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Layout from '@/layouts/main';
import AuthLayout from '@/layouts/auth';
import LoaderLayout from '@/layouts/loader';
import getRoleName from '@/helpers/getRoleName';
import getAccountStateName from '@/helpers/getAccountStateName';

export default {
    components: {
        'default-layout': Layout,
        AuthLayout,
        LoaderLayout
    },

    setup() {
        ChartJS.register(
            Zoom,
            Title,
            Tooltip,
            Filler,
            Legend,
            TimeScale,
            ArcElement,
            BarElement,
            LineElement,
            LinearScale,
            PointElement,
            CategoryScale
        );
    },

    data() {
        return {
            isUserValidated: false
        };
    },

    computed: {
        ...mapGetters({
            isLoggedIn: 'auth/isLoggedIn',
            darkLayerEnabled: 'layout/darkLayerEnabled'
        }),

        layout() {
            const { matched, meta } = this.$route;

            let layout = meta.layout || 'default';
            if (!matched.length) {
                layout = this.isLoggedIn ? 'default' : 'loader';
            }

            return layout;
        }
    },

    created() {
        this.setLoading(true);
        this.checkIsMobile();
    },

    errorCaptured(r1, r2, r3  , r4) {
        console.log(r1, r2, r3, r4);

    },

    mounted() {
        setTimeout(async () => {
            try {
                if (this.$route.meta.guestOnly) return;
                const user = await this.validateUser();

                if (this.$logRocket && user) {
                    if (this.$logRocket) {
                        this.$logRocket.identify(user.id, {
                            name: user.fullName,
                            email: user.email,
                            business_profile_id: user.businessProfile.id,
                            business_profile_name: user.businessProfile.name,
                            role: getRoleName(user.role),
                            account_state: getAccountStateName(user.state),
                            bp_active_user_count: user.businessProfile.activeAccountsCount,
                            user_teams: user.teams.map(team => team.name).join('; ')
                        });
                    }
                }

                this.setLoading(false);
                this.isUserValidated = true;
                const { redirectFrom = '' } = this.$route.query;

                const isQueryWithRedirect = Object.keys(this.$route.query).includes('redirectFrom');

                if (isQueryWithRedirect) {
                    const redirectRoute = !['/logout', '/login'].includes(redirectFrom)
                        ? redirectFrom
                        : { name: 'dashboard' };

                    this.$router.push(redirectRoute);
                }
            } catch (error) {
                console.log(error);
                if (this.$route.meta.guestOnly) return;
                this.clearUser();
                this.$router.push('/login');
                
            }
        }, 0);
    },

    methods: {
        ...mapActions({
            setLoading: 'setLoading',
            validateUser: 'auth/validate',
            checkIsMobile: 'isMobile/isMobile'
        }),

        ...mapMutations({
            clearUser: 'auth/CLEAR_USER'
        })
    }
};
</script>

<style>
.dark-layer {
    background-color: rgba(0, 0, 0, 0.4);
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: 99998;
}
</style>
